export const supportsPushNotifications = false;
export const supportsMediaPublishing = true;
// WEB-F4 covers canonical creation. The legacy edit path still consumes native
// filesystem URIs and stays disabled rather than exposing a broken action.
export const supportsMediaEditing = false;
export const supportsDurablePublishing = false;
